export default {"frames": [

{
	"filename": "01_three-eyes.png",
	"frame": {"x":1,"y":304,"w":355,"h":301},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":79,"y":82,"w":355,"h":301},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "02_three-eyes.png",
	"frame": {"x":1,"y":1,"w":356,"h":301},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":78,"y":82,"w":356,"h":301},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "03_three-eyes.png",
	"frame": {"x":1,"y":607,"w":355,"h":301},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":79,"y":82,"w":355,"h":301},
	"sourceSize": {"w":512,"h":512}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "three-eye.png",
	"format": "RGBA8888",
	"size": {"w":512,"h":1024},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:b07ae647ed615ff24d36e414e8cac530:531c1594c15c4027c776587ea080efe3:b9aae31d050d46fb0cf12695ebefa825$"
}
}
